<template>
  <div class="current-location" :class="isDiscolour?'discolour':''" v-if="locationList.length > 0">
    <div class="cl-wrapper">
      <div class="cl-tip">
        <el-image :src="require('@/assets/layout/area1.png')"></el-image>
        <span>您当前的位置:</span>
      </div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(v,i) in locationList" :key="i" :to="v.path">{{ v.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

  </div>
</template>

<script>
export default {
  name: "CurrentLocation",
  computed: {
    locationList() {
      let tempList = []
      if (['/', '/home'].indexOf(this.$route.path) === -1) {
        tempList[0] = {
          path: '/',
          title: '首页'
        }
        tempList = tempList.concat(this.$route.matched.filter(d => {
          return d.meta && d.meta.title
        }).map(d => {
          return {
            title: d.meta.title,
            path: d.path
          }
        }))
        if (['/product/classify', '/product/classify/'].indexOf(this.$route.path) !== -1 && this.$route.query.name && tempList.length === 1) {
          tempList = tempList.concat([
            {
              title: this.$route.query.name,
              path: this.$route.path
            }
          ])
        }
        if (['/product/detail', '/product/detail/'].indexOf(this.$route.path) !== -1 && this.$route.query.name && tempList.length === 1) {
          tempList = tempList.concat([
            {
              title: this.$route.query.name,
              path: `/product/classify?classifyId=${this.$route.query.classifyId}&name=${this.$route.query.name}`
            },
            {
              title: '产品详情',
              path: this.$route.path
            }
          ])
        }
      }
      return tempList
    },
    isDiscolour() {
      return ['/joins', '/about'].indexOf(this.$route.path) !== -1;
    }
  }
}
</script>

<style scoped lang="scss">
.current-location {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #F1F5FF;

  &.discolour {
    background-color: #FFFFFF;
  }

  .cl-wrapper {
    width: 1200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 0;

    .cl-tip {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 12px;

      .el-image {
        width: 16px;
        height: 16px;
      }

      span {
        font-size: 14px;
        color: #A4A4A4;
      }
    }
  }
}
</style>